export var PageMatchesOpEnum;
(function (PageMatchesOpEnum) {
    PageMatchesOpEnum["NOT"] = "NOT";
})(PageMatchesOpEnum || (PageMatchesOpEnum = {}));
export var DeviceTypeEnum;
(function (DeviceTypeEnum) {
    DeviceTypeEnum["ALL"] = "all";
    DeviceTypeEnum["DESKTOP"] = "desktop";
    DeviceTypeEnum["MOBILE"] = "mobile";
})(DeviceTypeEnum || (DeviceTypeEnum = {}));
export var PageMatchesTypeEnum;
(function (PageMatchesTypeEnum) {
    PageMatchesTypeEnum["EXACT"] = "exact";
    PageMatchesTypeEnum["SIMPLE"] = "simple";
    PageMatchesTypeEnum["CONTAINS"] = "contains";
    PageMatchesTypeEnum["BEGINS"] = "begins";
})(PageMatchesTypeEnum || (PageMatchesTypeEnum = {}));
export var DimensionNameEnum;
(function (DimensionNameEnum) {
    DimensionNameEnum["url"] = "URL";
    DimensionNameEnum["referrer"] = "REFERRER";
    DimensionNameEnum["os_type"] = "OS";
    DimensionNameEnum["number_of_visit"] = "VISIT_COUNT";
    DimensionNameEnum["time_on_page"] = "TIME_SPENT";
})(DimensionNameEnum || (DimensionNameEnum = {}));
export var DimensionStringTypeEnum;
(function (DimensionStringTypeEnum) {
    DimensionStringTypeEnum["equal_to"] = "EQ";
    DimensionStringTypeEnum["greater_than"] = "GT";
    DimensionStringTypeEnum["in_between"] = "IN";
})(DimensionStringTypeEnum || (DimensionStringTypeEnum = {}));
export var DimensionMatchesWithOtherEnum;
(function (DimensionMatchesWithOtherEnum) {
    DimensionMatchesWithOtherEnum["matches_simple"] = "simple";
    DimensionMatchesWithOtherEnum["contains"] = "contains";
    DimensionMatchesWithOtherEnum["begin_with"] = "begins";
})(DimensionMatchesWithOtherEnum || (DimensionMatchesWithOtherEnum = {}));
export var DimensionTimeRangeEnum;
(function (DimensionTimeRangeEnum) {
    DimensionTimeRangeEnum["all"] = "ALL";
    DimensionTimeRangeEnum["latest"] = "LATEST";
    DimensionTimeRangeEnum["today"] = "TODAY";
    DimensionTimeRangeEnum["past_week"] = "LAST_WEEK";
    DimensionTimeRangeEnum["past_month"] = "LAST_MONTH";
    DimensionTimeRangeEnum["time_range"] = "CUSTOM";
    DimensionTimeRangeEnum["before"] = "BEFORE";
    DimensionTimeRangeEnum["after"] = "AFTER";
})(DimensionTimeRangeEnum || (DimensionTimeRangeEnum = {}));
export var DimensionContainsEnum;
(function (DimensionContainsEnum) {
    DimensionContainsEnum["contains"] = "CONTAINS";
})(DimensionContainsEnum || (DimensionContainsEnum = {}));
